import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // « Annuler », the cross, the backdrop, Escape: the window goes (the links
  // to « # » used to leave it open — recette 08/10).
  close(event) {
    event?.preventDefault()
    this.clearFrame()
  }

  // A click beside the window, not in it
  closeOutside(event) {
    if (event.target === event.currentTarget) this.clearFrame()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.clearFrame()
  }

  clearFrame() {
    const modalFrame = document.querySelector('turbo-frame#modal')
    if (modalFrame) {
      modalFrame.innerHTML = ''
      modalFrame.removeAttribute('src')
    }
  }

  handleSubmit(event) {
    // Get all checked checkboxes
    const form = event.target
    const checkboxes = form.querySelectorAll('input[type="checkbox"][name="document_types[]"]')
    const checkedBoxes = Array.from(checkboxes).filter(cb => cb.checked && !cb.disabled)
    
    if (checkedBoxes.length === 0) {
      event.preventDefault()
      alert("Veuillez sélectionner au moins un document à télécharger.")
      return
    }

    // Close modal immediately after form submission
    setTimeout(() => this.clearFrame(), 100)

    // Monitor the iframe for errors
    const iframe = document.getElementById('download_iframe')
    if (iframe) {
      iframe.onload = () => {
        // Check if iframe content indicates an error (after a delay to allow download to start)
        setTimeout(() => {
          try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
            if (iframeDoc && iframeDoc.body) {
              const bodyText = iframeDoc.body.textContent || ''
              if (bodyText.includes('Erreur') || bodyText.includes('Aucun document')) {
                alert(bodyText.trim() || "Erreur lors du téléchargement.")
              }
            }
          } catch (e) {
            // Cross-origin or other error - assume download is working
            // This is expected for file downloads
          }
        }, 500)
      }
    }
  }
}

